export interface PageSpecification {
  title: string
  purpose: string
  functions: string[]
  connections: string[]
  app: string
}

export type GradeAccessRow = [grade: string, subscriptionType: string, drumAccess: string, cognitiveAccess: string]
export type StateDefinitionRow = [stateName: string, adminMeaning: string, appBehavior: string]

export interface PageSpecificationOptions {
  gradeAccessPolicy?: GradeAccessRow[]
  stateDefinitions?: StateDefinitionRow[]
}

export const gradeAccessPolicy: GradeAccessRow[] = [
  ['일반', '무료 회원', '공개된 곡 중 무료 회원 이용 허용 난이도', '인지 기본 공개 단계만 이용'],
  ['드러머', '드럼 유료 구독', '공개된 모든 드럼 악보와 Easy·Normal·Hard', '인지 무료 공개 범위만 이용'],
  ['인지', '인지 유료 구독', '드럼 무료 회원 이용 범위만 이용', '공개된 모든 인지 콘텐츠·단계'],
  ['플러스', '통합 유료 구독', '공개된 모든 드럼 악보와 모든 난이도', '공개된 모든 인지 콘텐츠·단계'],
]

function renderList(items: string[]) {
  return items.map((item) => `<li>${item}</li>`).join('')
}

function renderGradePolicySection(rows?: GradeAccessRow[]) {
  if (!rows) return ''
  const gradeRows = rows.map(([grade, type, drum, cognitive]) => `<tr><td><strong>${grade}</strong></td><td>${type}</td><td>${drum}</td><td>${cognitive}</td></tr>`).join('')
  return `<section class="section"><h2>사용자 등급별 접근 정책</h2><table class="policy-table"><thead><tr><th>등급</th><th>구독 유형</th><th>드럼 접근</th><th>인지 접근</th></tr></thead><tbody>${gradeRows}</tbody></table></section>`
}

function renderStateDefinitionSection(rows?: StateDefinitionRow[]) {
  if (!rows) return ''
  const stateRows = rows.map(([stateName, adminMeaning, appBehavior]) => `<tr><td><strong>${stateName}</strong></td><td>${adminMeaning}</td><td>${appBehavior}</td></tr>`).join('')
  return `<section class="section"><h2>상태값 정의와 사용자 앱 동작</h2><table class="policy-table"><thead><tr><th>상태값</th><th>관리자 의미</th><th>사용자 앱 동작</th></tr></thead><tbody>${stateRows}</tbody></table></section>`
}

function buildSpecificationHtml(spec: PageSpecification, dataModelGuide: string[], implementationGuide: string[], options: PageSpecificationOptions) {
  const gradePolicySection = renderGradePolicySection(options.gradeAccessPolicy)
  const stateDefinitionSection = renderStateDefinitionSection(options.stateDefinitions)
  return `<!doctype html><html lang="ko"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>${spec.title} 화면 사양서</title><style>body{margin:0;background:#f5f7fa;color:#191f28;font-family:Arial,'Noto Sans KR',sans-serif;font-size:14px;line-height:1.7}.wrap{max-width:1040px;margin:0 auto;padding:48px 36px 72px}.eyebrow{margin:0 0 6px;color:#0064ff;font-weight:700;font-size:12px}.title{margin:0;font-size:28px;letter-spacing:0}.lead{margin:10px 0 28px;color:#4e5968}.section{padding:22px 0;border-top:1px solid #e5e8eb}.section h2{margin:0 0 10px;font-size:17px}.section ul{margin:0;padding-left:20px;color:#4e5968}.section li+li{margin-top:7px}.app{padding:18px 20px;border:1px solid #d8e5ff;border-radius:8px;background:#f2f7ff}.app strong{display:block;margin-bottom:4px;color:#0064ff}.policy-table{width:100%;border-collapse:collapse;background:#fff;border:1px solid #e5e8eb;border-radius:8px;overflow:hidden}.policy-table th,.policy-table td{padding:10px 12px;border-bottom:1px solid #eef0f3;text-align:left;vertical-align:top}.policy-table th{background:#f8fafc;color:#6b7684;font-size:12px;font-weight:700}.policy-table tr:last-child td{border-bottom:0}.close{position:fixed;top:18px;right:18px;border:1px solid #e5e8eb;border-radius:7px;background:#fff;padding:8px 12px;color:#333;cursor:pointer}</style></head><body><button class="close" onclick="window.close()">닫기</button><main class="wrap"><p class="eyebrow">기획자·개발자 공통 화면 사양서</p><h1 class="title">${spec.title}</h1><p class="lead">${spec.purpose}</p><section class="section"><h2>이 화면에서 하는 일</h2><ul>${renderList(spec.functions)}</ul></section><section class="section"><h2>페이지 데이터와 연계 키</h2><ul>${renderList(dataModelGuide)}</ul></section>${gradePolicySection}${stateDefinitionSection}<section class="section"><h2>다른 관리자 화면과의 연결</h2><ul>${renderList(spec.connections)}</ul></section><section class="section"><h2>개발 구현 기준</h2><ul>${renderList(implementationGuide)}</ul></section><section class="section"><div class="app"><strong>사용자 앱 연동</strong>${spec.app}</div></section></main></body></html>`
}

export function openPageSpecification(
  spec: PageSpecification,
  dataModelGuide: string[],
  implementationGuide: string[],
  options: PageSpecificationOptions = {},
) {
  const specWindow = window.open('', '_blank', 'width=920,height=760')
  if (!specWindow) {
    return false
  }
  specWindow.document.write(buildSpecificationHtml(spec, dataModelGuide, implementationGuide, options))
  specWindow.document.close()
  return true
}
